import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "create-a-project-in-adobe-developer-console"
    }}>{`Create a project in Adobe Developer Console`}</h1>
    <p>{`UI Extensions, as with any App Builder application, are represented as projects in `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/developer-console/docs/guides/"
      }}>{`Adobe Developer Console`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`If you don't have access to the Adobe Developer Console, refer to the `}<a parentName="p" {...{
        "href": "../get-access"
      }}>{`Get Access`}</a>{` guide for instructions.`}</p>
    <p>{`To begin, we need to create a new Project that will provide us with the necessary configuration and resources.`}</p>
    <ol>
      <li parentName="ol">{`Sign in to `}<a parentName="li" {...{
          "href": "https://developer.adobe.com/console"
        }}>{`Adobe Developer Console`}</a>{` with your Adobe ID.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1128px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "68.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/1f0a11023afa81651361425edbb393db/5530d/create-project-1.webp 320w", "/uix/docs/static/1f0a11023afa81651361425edbb393db/0c8fb/create-project-1.webp 640w", "/uix/docs/static/1f0a11023afa81651361425edbb393db/86a10/create-project-1.webp 1128w"],
            "sizes": "(max-width: 1128px) 100vw, 1128px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/1f0a11023afa81651361425edbb393db/dd4a7/create-project-1.png 320w", "/uix/docs/static/1f0a11023afa81651361425edbb393db/0f09e/create-project-1.png 640w", "/uix/docs/static/1f0a11023afa81651361425edbb393db/bac97/create-project-1.png 1128w"],
            "sizes": "(max-width: 1128px) 100vw, 1128px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/1f0a11023afa81651361425edbb393db/bac97/create-project-1.png",
            "alt": "Sign in to Adobe Developer Console",
            "title": "Sign in to Adobe Developer Console",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Choose your account.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "68.12499999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/b37e7b30352b0f53a6cdfdad2e36ee95/5530d/create-project-2.webp 320w", "/uix/docs/static/b37e7b30352b0f53a6cdfdad2e36ee95/0c8fb/create-project-2.webp 640w", "/uix/docs/static/b37e7b30352b0f53a6cdfdad2e36ee95/cbd37/create-project-2.webp 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/b37e7b30352b0f53a6cdfdad2e36ee95/dd4a7/create-project-2.png 320w", "/uix/docs/static/b37e7b30352b0f53a6cdfdad2e36ee95/0f09e/create-project-2.png 640w", "/uix/docs/static/b37e7b30352b0f53a6cdfdad2e36ee95/64756/create-project-2.png 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/b37e7b30352b0f53a6cdfdad2e36ee95/64756/create-project-2.png",
            "alt": "Choose your account",
            "title": "Choose your account",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Choose your profile or organization.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1138px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "69.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/74c5da15c7058f9d3383cad7cd8b8a51/5530d/create-project-3.webp 320w", "/uix/docs/static/74c5da15c7058f9d3383cad7cd8b8a51/0c8fb/create-project-3.webp 640w", "/uix/docs/static/74c5da15c7058f9d3383cad7cd8b8a51/58ffc/create-project-3.webp 1138w"],
            "sizes": "(max-width: 1138px) 100vw, 1138px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/74c5da15c7058f9d3383cad7cd8b8a51/dd4a7/create-project-3.png 320w", "/uix/docs/static/74c5da15c7058f9d3383cad7cd8b8a51/0f09e/create-project-3.png 640w", "/uix/docs/static/74c5da15c7058f9d3383cad7cd8b8a51/0ff2a/create-project-3.png 1138w"],
            "sizes": "(max-width: 1138px) 100vw, 1138px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/74c5da15c7058f9d3383cad7cd8b8a51/0ff2a/create-project-3.png",
            "alt": "Choose your profile",
            "title": "Choose your profile",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Make sure you are in a proper organization (a switcher is in the right top corner).`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "644px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "36.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/478f3180cfeebf7c2b55fcad8edc90b7/5530d/create-project-4.webp 320w", "/uix/docs/static/478f3180cfeebf7c2b55fcad8edc90b7/0c8fb/create-project-4.webp 640w", "/uix/docs/static/478f3180cfeebf7c2b55fcad8edc90b7/ce8f6/create-project-4.webp 644w"],
            "sizes": "(max-width: 644px) 100vw, 644px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/478f3180cfeebf7c2b55fcad8edc90b7/dd4a7/create-project-4.png 320w", "/uix/docs/static/478f3180cfeebf7c2b55fcad8edc90b7/0f09e/create-project-4.png 640w", "/uix/docs/static/478f3180cfeebf7c2b55fcad8edc90b7/e8cbb/create-project-4.png 644w"],
            "sizes": "(max-width: 644px) 100vw, 644px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/478f3180cfeebf7c2b55fcad8edc90b7/e8cbb/create-project-4.png",
            "alt": "Check organization",
            "title": "Check organization",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Click "Create new project" -> "Project from template":`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "23.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/5530d/create-project-5.webp 320w", "/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/0c8fb/create-project-5.webp 640w", "/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/94b1e/create-project-5.webp 1280w", "/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/a012d/create-project-5.webp 1293w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/dd4a7/create-project-5.png 320w", "/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/0f09e/create-project-5.png 640w", "/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/bbbf7/create-project-5.png 1280w", "/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/b1a45/create-project-5.png 1293w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/f3c755dd67fcc9fd6a3983099ff9112a/bbbf7/create-project-5.png",
            "alt": "Create project from template",
            "title": "Create project from template",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`And choose "App Builder":`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1151px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "38.125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/5add23d76c85336ea941765bde4ac1a6/5530d/create-project-6.webp 320w", "/uix/docs/static/5add23d76c85336ea941765bde4ac1a6/0c8fb/create-project-6.webp 640w", "/uix/docs/static/5add23d76c85336ea941765bde4ac1a6/3cdea/create-project-6.webp 1151w"],
            "sizes": "(max-width: 1151px) 100vw, 1151px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/5add23d76c85336ea941765bde4ac1a6/dd4a7/create-project-6.png 320w", "/uix/docs/static/5add23d76c85336ea941765bde4ac1a6/0f09e/create-project-6.png 640w", "/uix/docs/static/5add23d76c85336ea941765bde4ac1a6/b86f2/create-project-6.png 1151w"],
            "sizes": "(max-width: 1151px) 100vw, 1151px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/5add23d76c85336ea941765bde4ac1a6/b86f2/create-project-6.png",
            "alt": "Choose \"App Builder\"",
            "title": "Choose \"App Builder\"",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Fill in the project data.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "34.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/5530d/create-project-7.webp 320w", "/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/0c8fb/create-project-7.webp 640w", "/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/94b1e/create-project-7.webp 1280w", "/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/91ec5/create-project-7.webp 1816w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/dd4a7/create-project-7.png 320w", "/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/0f09e/create-project-7.png 640w", "/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/bbbf7/create-project-7.png 1280w", "/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/ded97/create-project-7.png 1816w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/9fe1fcfa22c05d48435c891131a9ebf2/bbbf7/create-project-7.png",
            "alt": "Fill the project data",
            "title": "Fill the project data",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Project Title`}</inlineCode>{` is used to identify your project within `}<a parentName="li" {...{
          "href": "https://developer.adobe.com/console"
        }}>{`Adobe Developer Console`}</a>{` and in `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aio-cli"
        }}>{`CLI`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`App Name`}</inlineCode>{` will be used as a unique identifier for your application and this value cannot be changed after project creating.`}</li>
    </ul>
    <p>{`After creating, you should see a new project generated with 2 default Workspaces.
Each App Builder project has two default workspaces: `}<inlineCode parentName="p">{`Production`}</inlineCode>{` and `}<inlineCode parentName="p">{`Stage`}</inlineCode>{`. You can add more workspaces as needed.
The `}<inlineCode parentName="p">{`Production`}</inlineCode>{` workspace is special, as it is used for the submission and distribution flow.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1034px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "51.25000000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/cd8f3e5d6109be5abad0234baa362b85/5530d/create-project-8.webp 320w", "/uix/docs/static/cd8f3e5d6109be5abad0234baa362b85/0c8fb/create-project-8.webp 640w", "/uix/docs/static/cd8f3e5d6109be5abad0234baa362b85/e4622/create-project-8.webp 1034w"],
            "sizes": "(max-width: 1034px) 100vw, 1034px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/cd8f3e5d6109be5abad0234baa362b85/dd4a7/create-project-8.png 320w", "/uix/docs/static/cd8f3e5d6109be5abad0234baa362b85/0f09e/create-project-8.png 640w", "/uix/docs/static/cd8f3e5d6109be5abad0234baa362b85/b69f7/create-project-8.png 1034w"],
            "sizes": "(max-width: 1034px) 100vw, 1034px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/cd8f3e5d6109be5abad0234baa362b85/b69f7/create-project-8.png",
            "alt": "A new project with 2 default Workspaces",
            "title": "A new project with 2 default Workspaces",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      